export default __webpack_public_path__ + "static/media/DAIF_Infra_In.bf0ebd0c.mp4";